import React from 'react';

function TextSourceIcon() {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.6001 81.2002V84.3233L54.654 73.7829C56.2156 72.6118 58.1675 71.831 60.3146 71.831H87.4464C89.008 71.831 90.5695 70.4646 90.5695 68.7079V12.4923C90.5695 10.9308 89.008 9.36926 87.4464 9.36926H12.4923C10.7356 9.36926 9.36926 10.9308 9.36926 12.4923V68.7079C9.36926 70.4646 10.7356 71.831 12.4923 71.831H31.2309C36.3059 71.831 40.6001 76.1252 40.6001 81.2002ZM40.4049 96.2301L39.429 96.8157L36.1107 99.3532C35.1347 100.134 33.9636 100.134 32.7924 99.7436C31.8164 99.158 31.2309 98.182 31.2309 96.8157V81.2002H12.4923C5.4654 81.2002 0 75.7348 0 68.7079V12.4923C0 5.66059 5.4654 0 12.4923 0H87.4464C94.2782 0 99.9388 5.66059 99.9388 12.4923V68.7079C99.9388 75.7348 94.2782 81.2002 87.4464 81.2002H60.3146L40.6001 96.0349L40.4049 96.2301Z"
        fill="#6754E2"
      />
      <path
        d="M21.8616 40.6001C21.8616 44.1136 24.5943 46.8463 28.1078 46.8463C31.4261 46.8463 34.354 44.1136 34.354 40.6001C34.354 37.2818 31.4261 34.354 28.1078 34.354C24.5943 34.354 21.8616 37.2818 21.8616 40.6001Z"
        fill="#C9C2F5"
      />
      <path
        d="M49.9694 46.8463C53.2877 46.8463 56.2156 44.1136 56.2156 40.6001C56.2156 37.2818 53.2877 34.354 49.9694 34.354C46.4559 34.354 43.7232 37.2818 43.7232 40.6001C43.7232 44.1136 46.4559 46.8463 49.9694 46.8463Z"
        fill="#C9C2F5"
      />
      <path
        d="M65.5848 40.6001C65.5848 44.1136 68.3175 46.8463 71.831 46.8463C75.1493 46.8463 78.0772 44.1136 78.0772 40.6001C78.0772 37.2818 75.1493 34.354 71.831 34.354C68.3175 34.354 65.5848 37.2818 65.5848 40.6001Z"
        fill="#C9C2F5"
      />
    </svg>
  );
}
export default TextSourceIcon;
